import Vue from 'vue'
import Router from 'vue-router'
import BasicLayout from '@/layouts/Basic'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  // mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: 'dashboard/alpha',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        // Learner Dashboard
        {
          path: '/dashboard/alpha',
          name: 'dashboard',
          meta: {
            title: 'Dashboard',
          },
          component: () => import('./views/dashboard/alpha'),
        },
        // Admin Dashboard
        {
          path: '/dashboard/gamma',
          name: 'adminDashboard',
          meta: {
            title: 'Dashboard',
          },
          component: () => import('./views/dashboard/gamma'),
        },
        // Content
        {
          path: '/content/study/:topicId/:pageNum',
          meta: {
            title: 'Content',
            reuse: false,
          },
          component: () => import('./views/content/study'),
          props: true,
          // props: route => ({ query: route.query.cat }),
        },
        // Lists
        {
          path: '/lists/saved',
          meta: {
            title: 'Saved Questions',
          },
          component: () => import('./views/lists/saved'),
        },
        // Profile
        {
          path: '/profile',
          name: 'profile',
          meta: {
            title: 'Profile',
          },
          component: () => import('./views/profile'),
        },
      ],
    },

    // Pricing
    {
      path: '/account',
      component: BasicLayout,
      redirect: 'account/pricing',
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        {
          path: 'pricing',
          name: 'pricing',
          meta: {
            title: 'Pricing',
          },
          component: () => import('./views/account/pricing'),
        },
      ],
    },

    // Order
    {
      path: '/order',
      component: BasicLayout,
      redirect: 'account/pricing',
      meta: {
        authRequired: false,
        hidden: true,
      },
      children: [
        {
          path: 'success',
          name: 'success',
          meta: {
            title: 'Success',
          },
          component: () => import('./views/order/success'),
        },
        {
          path: 'cancel',
          name: 'cancel',
          meta: {
            title: 'Cancel',
          },
          component: () => import('./views/order/cancel'),
        },
      ],
    },

    // System Pages
    {
      path: '/auth',
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          meta: {
            title: 'Sign In',
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*', redirect: 'auth/404', hidden: true,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired) && !store.state.user.authorized) {
    next({
      path: '/auth/login',
      query: { redirect: to.fullPath },
    })
  } else {
    next()
  }
})

export default router
